import { Slugs } from '@thinkalpha/common/constants/slugs.js';
import { FieldTypeCategory } from '@thinkalpha/language-services';
import type { TemplateColumn } from '@thinkalpha/ui-types/contracts/column-template';
import { registerClientColumn } from 'src/features/clientColumns';
import type { ClientColumnDefinition } from 'src/features/clientColumns';
import NewsGridCell from 'src/features/newsHoverCard/NewsGridCell.svelte';
import { generateDefaultDisplaySetting } from 'src/routes/dashboard/widget-container/widget-settings-editor/context';
import { v4 } from 'uuid';

/** The clientKey for the News column type */
export const NEWS_CLIENT_KEY = 'news';

/**
 * Creates a new News client column for use in column templates.
 */
export function createNewsClientColumn(): TemplateColumn {
    return {
        id: v4(),
        name: 'News',
        type: 'client',
        clientKey: NEWS_CLIENT_KEY,
        dataType: FieldTypeCategory.String,
        unit: null,
        visible: true,
        displaySettings: [generateDefaultDisplaySetting()],
    };
}

/**
 * Client column definition for News.
 * This is registered with the clientColumnRegistry.
 */
export const newsClientColumnDefinition: ClientColumnDefinition = {
    clientKey: NEWS_CLIENT_KEY,
    displayName: 'News',
    tableKey: 'strategy',
    requiredSlugs: [Slugs.symbol, Slugs.symbolChangeClose],
    createGridCell: ({ resolvedFieldIds }) => ({
        component: NewsGridCell,
        props: {
            symbolFieldId: resolvedFieldIds?.[Slugs.symbol] ?? '',
            changeCloseFieldId: resolvedFieldIds?.[Slugs.symbolChangeClose] ?? '',
        },
    }),
    createColumn: createNewsClientColumn,
};

/**
 * Register the News client column with the registry.
 * This should be called during application initialization.
 */
export function registerNewsClientColumn(): void {
    registerClientColumn(newsClientColumnDefinition);
}
